var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isLoading)?[_c('Loading')]:[_c('MyHeader',{attrs:{"msg":_vm.$t('agenda.header')}}),_c('v-container',[_c('div',{staticClass:"mt-6 mb-6"},[_c('Agenda',{attrs:{"sessions":_vm.sessionsItems}})],1)])]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }